// GI31 일반출고 — moms-be(2.0) 호출부. moms-be-1.0(`/api/grid/*`, `/api/common/*`) 경로는 쓰지 않는다.
// 1.0 도 GI31 만은 이미 아래 2.0 경로로 분기하고 있었다(moms-fe-1.0 `store/modules/grid.js`
// searchEpic·saveEpic·sendEpic 의 GI31 분기) — 계약이 운영에서 검증된 상태다.
import request from '@/utils/request'
import { menuCodeHeaders } from '@/utils/menuCodeHeaders'
import {
  ConfirmGeneralOutboundPayload,
  ConfirmGeneralOutboundRes,
  OutboundProgress,
  SaveGeneralOutboundPayload,
  SaveGeneralOutboundRes,
  SearchGeneralOutboundParams,
  SearchGeneralOutboundRes,
} from '@/services/outbound/generalOutbound/types'

// 1.0 GI31 도 같은 API 를 헤더 없이 부른다 — BE 는 X-Menu-Code 가 GI37 일 때만 감사 로그를 남긴다(LOGISPRD-16047)
const GI37_HEADERS = menuCodeHeaders('GI37')

/**
 * 일반출고 조회.
 *
 * BE `SearchGeneralOutboundRequestBody` 가 `params` 를 **문자열 한 개**로 받아 안에서 다시 파싱한다.
 * 객체를 그대로 보내면 역직렬화에서 400 이 난다.
 */
export const searchGeneralOutbounds = (params: SearchGeneralOutboundParams) =>
  request.post<SearchGeneralOutboundRes, { params: string }>('/api/v1/get-general-outbounds', { params: JSON.stringify(params) }, GI37_HEADERS)

/**
 * 일반출고 저장.
 *
 * 조회와 같은 이유로 본문이 `data` 문자열 한 개다. 응답은 즉시 완료가 아니라 접수(progressKey)이며,
 * SKU 미해소면 422 로 떨어지므로 호출부에서 `error.response.data` 를 읽어야 한다.
 */
export const saveGeneralOutbounds = (payload: SaveGeneralOutboundPayload) =>
  request.post<SaveGeneralOutboundRes, { data: string }>('/api/v1/save-general-outbounds', { data: JSON.stringify(payload) }, GI37_HEADERS)

/** 일반출고 확정. 저장과 달리 본문을 문자열로 감싸지 않는다(BE `ConfirmGeneralOutboundRequestBody`). */
export const confirmGeneralOutbounds = (payload: ConfirmGeneralOutboundPayload) =>
  request.post<ConfirmGeneralOutboundRes, ConfirmGeneralOutboundPayload>('/api/v1/confirm-general-outbounds', payload, GI37_HEADERS)

/** 저장 진행률. 워크플로가 끝나지 않았으면 data 가 null 로 온다. */
export const getOutboundProgress = (progressKey: string) =>
  request.get<ApiResponseV2<OutboundProgress | null>>(`/api/v1/outbound-progress/${progressKey}`)
